'use strict';

module.exports = function($stateProvider) {

    $stateProvider
        .state('dashboard.departments.department.admin', {
            url: '/admin',
            templateUrl: 'dashboard-department-admin/dashboard-department-admin.html',
            controller: 'dashboardDepartmentAdminCtrl as ctrl',
            resolve: {
                owners: ['Department', '$state', function(Department, $state) {
                    return;
                }]
            },
            data: {
                authorizedRoles: ['admin','owner']
            }
        });
};
